import React from "react"
import g from "glamorous"
import { css } from "glamor"
import PageContainer from "../components/page-container.jsx"
import Navigation from "../components/navigation.jsx"
import Footer from "../components/footer.jsx";

//import WorkListItem from "../components/work-list-item.js"
//import ProductList from "../components/product-list.jsx"

const WorkAside = g.aside({
    paddingTop: `1.5em`,
    ':before': {
        borderTop: `1px solid black`,
        content: ` `,
        width: `100%`,
        display: `block`,
        marginBottom: `3em`
    }
})

const Main = g.main({
    overflow: `auto`
})

export default ({ children, data }) =>
    <PageContainer>
        <Navigation></Navigation>
        <Main>
            {children()}
        </Main>
        <Footer></Footer>
    </PageContainer>

/*export const query = graphql`
    query LayoutQuery {
        site {
            siteMetadata {
                title
            }
        }
        allContentfulWork(limit: 1000) {
            totalCount
            edges {
                node {
                    id
                    title
                    photos {
                        description
                        file {
                            url
                        }
                    }
                    fields {
                        slug
                    }
                }
            }
        }
    }
`*/


// WEBPACK FOOTER //
// ./src/layouts/index.js